import { acceptHMRUpdate, defineStore } from 'pinia'

import { type OrganizationPolicy } from '~/types.ts'

export const usePolicies = defineStore('policies', () => {
  const policies = reactive<OrganizationPolicy>({} as OrganizationPolicy)
  const defaults = reactive<OrganizationPolicy>({} as OrganizationPolicy)

  async function save(updates: { policies: Partial<OrganizationPolicy>; on_policy_change?: string; apply_monitoring_frequency_to_cases?: boolean }) {
    try {
      const { data } = await api.patch<OrganizationPolicy>(`organization-policies/${stores.organization.id}`, updates)
      Object.assign(policies, data)
    } catch (error) {
      if (!isAbortError(error)) {
        $message.error($t('api-error'))

        throw error
      }
    }
  }

  function reset(keys: (keyof OrganizationPolicy)[] = []) {
    for (const key of keys) {
      // @ts-expect-error - keys are the same.
      this.policies[key] = this.defaults[key]
    }
  }

  return { policies, defaults, save, reset }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(usePolicies, import.meta.hot))
}
